import React from "react";
import {Typography} from "../../../../designSystem/components/Typography";
import {CATEGORIES_MAPPING} from "../../../../utils/constants";

export const ApplicationFormTitle = ({
  category,
}) => (
  <React.Fragment>
    <Typography variant="title">
      {CATEGORIES_MAPPING[category]}服務申請
    </Typography>
    <Typography variant="subtitle">
      請勾選個案符合之項目(需多選)
    </Typography>
  </React.Fragment>
)